@if (modalOpen) {
    <div class="modal-backdrop show"></div>
}
<ycn-modal-base [open]="modalOpen">
    <ycn-simple-modal-header
        [header]="'Refresh Required'"
        [showCloseButton]="false">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section">
            <div class="modal-message" [innerHTML]="refreshMessage"></div>
        </div>
    </div>
    <ycn-simple-modal-footer
        [showCancelButton]="false"
        [showSubmitButton]="false">
    </ycn-simple-modal-footer>
</ycn-modal-base>
